import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-382f5ee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = {
  href: "https://oona.win/privacy",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_3 = {
  href: "https://oona.win/Oona_Mention_legales.pdf",
  target: "_blank",
  rel: "noopener noreferrer"
}

import IconExternalLink from "@/assets/icons/externalLink.vue";
import i18n from "@/i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", null, "©" + _toDisplayString(new Date().getFullYear()) + " Oona. All rights reserved.", 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("a", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t("footer.privacyPolicy")) + " ", 1),
        _createVNode(IconExternalLink)
      ]),
      _createElementVNode("a", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t("footer.legalNotice")) + " ", 1),
        _createVNode(IconExternalLink)
      ])
    ])
  ]))
}
}

})